import styled from "styled-components";
import { Device } from "../../components/device";

export const CustomIcon = styled.span<{ textColor?: string }>`
    display: inline-block !important;
    ${Device.laptop} {
        display: none !important;
    }
    svg {
        stroke: ${(props) => props.textColor} !important;
        width: 1.25rem;
        height: 1.25rem;
        fill: transparent;
        stroke-width: 4px;
        animation: none;
        transition: fill 0.5s linear;
    }
`;

export const CustomIconNoHide = styled.span<{ textColor?: string }>`
    display: inline-block !important;
    svg {
        stroke: ${(props) => props.textColor} !important;
        width: 1.25rem;
        height: 1.25rem;
        fill: transparent;
        stroke-width: 4px;
        animation: none;
        transition: fill 0.5s linear;
    }
`;
